// 路由权限仓库

const permission = {
  state: {
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
    },
    SET_CLEAR_PERMISSION:(state)=> {
      state.addRouters = [];
    },
  },
  actions: {
    GenerateRoutes({commit}, routerdata) {
      return new Promise(resolve => {
        commit('SET_ROUTERS', routerdata);
        resolve();
      })
    },
    ClearPermission({commit}){
      commit('SET_CLEAR_PERMISSION');
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js